
const nest = {

  expand: function(v, parents, expandedProp){
    let expanded = {...expandedProp}
    if(parents.length===0){
      if(expanded[v]) 
        delete expanded[v]
      else expanded[v] = {}
    } else if(parents.length===1){
      if(expanded[parents[0]][v]) 
        delete expanded[parents[0]][v]
      else expanded[parents[0]][v]={}
    } else if(parents.length===2){
      if(expanded[parents[0]][parents[1]][v]) 
        delete expanded[parents[0]][parents[1]][v]
      else expanded[parents[0]][parents[1]][v]={}
    } else if(parents.length===3){
      if(expanded[parents[0]][parents[1]][parents[2]][v]) 
        delete expanded[parents[0]][parents[1]][parents[2]][v]
      else expanded[parents[0]][parents[1]][parents[2]][v]={}
    } else if(parents.length===4){
      if(expanded[parents[0]][parents[1]][parents[2]][parents[3]][v])
        delete expanded[parents[0]][parents[1]][parents[2]][parents[3]][v]
      else expanded[parents[0]][parents[1]][parents[2]][parents[3]][v]={}
    } 
    return(expanded)
  },

  checkIfExpanded: function(v,parents,expandedProp){
    let expanded = {...expandedProp}
    if(parents.length===0){
      if(expanded[v]) return true
    } else if(parents.length===1){
      if(expanded[parents[0]][v]) return true
    } else if(parents.length===2){
      if(expanded[parents[0]][parents[1]][v]) return true
    } else if(parents.length===3){
      if(expanded[parents[0]][parents[1]][parents[2]][v]) return true
    } else if(parents.length===4){
      if(expanded[parents[0]][parents[1]][parents[2]][parents[3]][v]) return true
    } 
    return false
  }

}


export default nest




// WEBPACK FOOTER //
// ./src/lib/wizard/stepTypes/utils/nestExpand.js